import styled from "styled-components";

const TooltipBox = styled.div`
  background: white;
  color: black;
  font-size: 12px;
  border-radius: 6px;
  padding: 10px;
  width: 180px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

export default TooltipBox;
